export default __webpack_public_path__ + "static/grzybica-paznokci-c7ec7fe4301bc022245cff7fa37fe960.png";